// e-content-form.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { EcontentServicesService } from '../../../inputfileds/form_services/econtent-services/econtent-services.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
    selector: 'app-e-content-form',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        DynamicFormQuestionComponent,
        MatCardModule,
        ReactiveFormsModule,
        TranslateDirective
    ],
    templateUrl: './e-content-form.component.html',
    styleUrls: ['./e-content-form.component.scss']
})
export class EContentFormComponent implements OnInit {
  @Input() questions: Inputfiledsbase<string>[] | null = [];
  @Input() form!: FormGroup;
  @Output() submitForm = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  fileToUpload: File | null = null;
  filePreview: string | null = null;
  fileName: string | null = null;
  isImage: boolean = false;
  fromcontrols:any = {};
  
  constructor(private apiservice:ApiservicesService, private eContentFormQuestions:EcontentServicesService){
    this.fromcontrols = this.eContentFormQuestions.getformCls();
  }

  ngOnInit(): void {
     if(Object.keys(this.fromcontrols).length > 0){
      this.eContentFormQuestions.onCourseChange(this.fromcontrols.courseId);
      this.eContentFormQuestions.onSemesterChange(this.fromcontrols.semesterId);
      const data = {
          courses_id:this.fromcontrols.courseId,
          semister_id:this.fromcontrols.semesterId,
          courses_medium:'',
          subject_id:this.fromcontrols.subjectId,
          category_id:'',
          econtent_title:''
      }
      this.form.patchValue(data);
      this.form.controls['courses_id']?.disable();
      this.form.controls['semister_id']?.disable();
      this.form.controls['subject_id']?.disable();
    } else{
      this.form?.enable();
      this.form?.reset();
    }
  }


  onSubmit() {
    if (this.form.valid) {
      const formData = new FormData();
      
      formData.append('title', this.form.value['econtent_title']);
      formData.append('category_id', this.form.value['category_id']);

      if(Object.keys(this.fromcontrols).length > 0){
      formData.append('course_id',  this.fromcontrols.courseId);
      formData.append('semester_id',this.fromcontrols.semesterId);
      formData.append('subject_id',this.fromcontrols.subjectId);
      }else{
      formData.append('course_id', this.form.value['courses_id']);
      formData.append('semester_id', this.form.value['semister_id']);
      formData.append('subject_id', this.form.value['subject_id']);
      }

      if (this.fileToUpload) {
        formData.append('econtent_media', this.fileToUpload); // 👈 Add the actual file
      }
      this.submitForm.emit(formData); // 👈 Emit full FormData to parent
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileToUpload = input.files[0];
      // this.fileName = this.fileToUpload.name;
      // this.isImage = this.fileToUpload.type.startsWith('image/');
      // if (this.isImage) {
      if (this.fileToUpload) {
        this.fileName = this.fileToUpload.name;
        const reader = new FileReader();
        reader.onload = () => {
          this.filePreview = reader.result as string;
        };
        reader.readAsDataURL(this.fileToUpload);
      } else {
        this.filePreview = null;
      }
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}
